import {User} from "oidc-client-ts";
import SiteConfig from "../siteConfig";

function getUser() {
  const oidcStorage = localStorage.getItem(`oidc.user:${SiteConfig.COGNITO_AUTHORITY}:${SiteConfig.COGNITO_CLIENT_ID}`)
  if (!oidcStorage) {
    return null;
  } 

  return User.fromStorageString(oidcStorage);
}

function getToken() {
  const user = getUser();
  if (!user) return null;
  return user?.id_token;
}

function isTokenExpired(token) {
  if (!token) {
    return true;
  }

  const payloadBase64 = token.split('.')[1];
  const payload = JSON.parse(atob(payloadBase64));
  const currentTime = Math.floor(Date.now() / 1000);

  return payload.exp < currentTime;
}

function isAdmin() {
  const user = getUser();
  if (!user) return false;
  
  const { 'cognito:groups': groups } = user?.profile;
  return Array.isArray(groups) && groups.includes("Admins");
}

function getUserId() {
  const user = getUser();
  if (!user) return null;
  return user?.profile.sub
}

function getAccountHolderId() {
  const user = getUser();
  if (user) {
    const {'custom:accountHolderIds': accountHolderIds} = user?.profile;
    if (!accountHolderIds & isAdmin()) {
      return "admin";
    }
    return accountHolderIds?.split(',')[0];
  }
  return null;
}

export { getToken, isAdmin, getUserId, isTokenExpired, getAccountHolderId };